import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {IProvinceResponse} from '../../shared/models/i-province-response';

@Injectable({
  providedIn: 'root',
})
export class GeographyService {
  provincesSubject: BehaviorSubject<IProvinceResponse[]> = new BehaviorSubject<IProvinceResponse[]>([]);
  provinces$: Observable<IProvinceResponse[]> = this.provincesSubject.asObservable();

  setProvinces(provinces: IProvinceResponse[]): void {
    this.provincesSubject.next(provinces);
  }
}
